import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { ReferenceFragment } from '../../../../common/list/fragments';

export const saveBookingForResource: DocumentNode = gql`
    mutation SaveBookingForResource($resourceId: ID!, $input: OpportunityInput!) {
        saveBookingForResource(resourceId: $resourceId, input: $input) {
            id
            errors {
                field
                key
                message
            }
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;
